import { BANK_LIST } from "./apiRoutes";
import { authData } from "./Service";

/**
 * Fetch the full bank list.
 * Omit pagination/filters to get all banks in one call.
 */
export const bankListApi = async (data = {}) => {
  const response = await authData.post(BANK_LIST, data);
  return response?.data;
};
